import _ from 'lodash';
import { FormError, FormField } from './model';

export const convertStringInFields = <T>(disabledFields: string[]): FormField<T>[] => {
  return disabledFields.map((el) => {
    let keys = _.toPath(el);
    let key = keys[0];
    let path = keys.length > 1 ? _.slice(keys, 1, keys.length) : undefined;
    return { field: key, path: path } as FormField<T>;
  });
};

export const isFormField = <T>(field: any): field is FormField<T> => {
  return field && field.field !== undefined;
};

export const isFormError = <T>(err: any): err is FormError<T> => {
  return err && err.field !== undefined && err.error !== undefined;
};
